var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "article",
    {
      staticClass: "changelog-entry",
      class: [
        `changelog-entry--${_vm.variant}`,
        {
          "changelog-entry--first": _vm.isFirst,
          "changelog-entry--last": _vm.isLast,
        },
      ],
    },
    [
      _vm._m(0),
      _c("div", { staticClass: "changelog-entry__body" }, [
        _c("div", { staticClass: "changelog-entry__meta" }, [
          _c("p", { staticClass: "changelog-entry__date-version" }, [
            _vm.formattedDate
              ? _c("span", { staticClass: "changelog-entry__date" }, [
                  _vm._v(_vm._s(_vm.formattedDate)),
                ])
              : _vm._e(),
            _vm.entry.version
              ? _c("span", { staticClass: "changelog-entry__version" }, [
                  _vm._v(_vm._s(_vm.entry.version)),
                ])
              : _vm._e(),
          ]),
          _vm.typeLabel
            ? _c("span", { staticClass: "changelog-entry__type" }, [
                _vm._v(_vm._s(_vm.typeLabel)),
              ])
            : _vm._e(),
        ]),
        _c("div", { staticClass: "changelog-entry__card" }, [
          _c("div", { staticClass: "changelog-entry__content" }, [
            _c("h3", { staticClass: "changelog-entry__title" }, [
              _vm._v(" " + _vm._s(_vm.entry.title) + " "),
            ]),
            _vm.entry.description
              ? _c("p", { staticClass: "changelog-entry__description" }, [
                  _vm._v(" " + _vm._s(_vm.entry.description) + " "),
                ])
              : _vm._e(),
          ]),
          _vm.entry.items && _vm.entry.items.length
            ? _c(
                "ul",
                { staticClass: "changelog-entry__items" },
                _vm._l(_vm.entry.items, function (item, index) {
                  return _c("li", { key: index }, [
                    _vm._v(" " + _vm._s(item) + " "),
                  ])
                }),
                0
              )
            : _vm._e(),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "changelog-entry__axis" }, [
      _c("span", { staticClass: "changelog-entry__dot" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }